import { useEffect, useState } from 'react';
import { RemoteParticipant } from 'twilio-video';
import { useSelector } from 'react-redux';
import { RootReducer, StreamingReducer } from '../../../../models/Redux';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useDominantSpeaker() {
    const {
        localStreamingState: { room },
    } = useSelector<RootReducer, StreamingReducer>(state => state.streaming);
    const [dominantSpeaker, setDominantSpeaker] = useState(room?.dominantSpeaker ?? null);

    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (room) {
            // Sometimes, the 'dominantSpeakerChanged' event can emit 'null', which means that
            // there is no dominant speaker. If we change the main participant when 'null' is
            // emitted, the effect can be jarring to the user. Here we ignore any 'null' values
            // and continue to display the previous dominant speaker as the main participant.
            const handleDominantSpeakerChanged = (newDominantSpeaker: RemoteParticipant) => {
                setDominantSpeaker(newDominantSpeaker);
            };

            room.on('dominantSpeakerChanged', handleDominantSpeakerChanged);
            return () => {
                room.off('dominantSpeakerChanged', handleDominantSpeakerChanged);
            };
        }
    }, [room]);

    return dominantSpeaker;
}
